import { render, staticRenderFns } from "./SidebarProject.vue?vue&type=template&id=5048d372&scoped=true"
import script from "./SidebarProject.vue?vue&type=script&lang=js"
export * from "./SidebarProject.vue?vue&type=script&lang=js"
import style0 from "./SidebarProject.css?vue&type=style&index=0&id=5048d372&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5048d372",
  null
  
)

export default component.exports